import React from "react";
import {
  Card,
  // CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Paper,
} from "@material-ui/core";
import { ButtonSaveAndClose } from "theme";
import { AddCircle, Delete } from "@material-ui/icons";
function LoginAssignProgramsList(props) {
  const TESTmethod_DELETE = (programID) => {
    props.funcUnAssignProgram(programID);
  };
  const TESTmethod_ADD = (programID) => {
    props.funcAssignProgram(programID);
  };
  return (
    <div>
      <Paper>
        <CardHeader
											// Add button to top right corner
											// action={
											//     <ButtonSaveAndClose
											//         size="small">
											//         <AddCircle />
											//     </ButtonSaveAndClose>
											// }
          title="Remove Programs Access"
        />
        <Divider />
        <Card>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {props.programsAssigned ? (
                  <>
                    {props.programsAssigned.map((program, index, props) => {
                      return (
                        <Grid key={index} container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <b>{program.description}</b>
                          </Grid>
                          <Grid item xs={12} sm={4}></Grid>
                          <Grid item xs={12} sm={4}>
                            <ButtonSaveAndClose
                              size="large"
                              onClick={() => {
                                TESTmethod_DELETE(program.id);
                              }}
                            >
                              <Delete />
                            </ButtonSaveAndClose>
                          </Grid>
                        </Grid>
                      );
                    })}
                  </>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <CardHeader
										// Add button to top right corner
										// action={
										//     <ButtonSaveAndClose
										//         size="small">
										//         <AddCircle />
										//     </ButtonSaveAndClose>
										// }
          title="Grant Programs Access"
        />
        <Divider />
        <Card>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {props.programsNotAssigned ? (
                  <>
                    {props.programsNotAssigned.map((program, index) => {
                      return (
                        <Grid key={index} container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <b>{program.description}</b>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <ButtonSaveAndClose
                              size="large"
                              onClick={() => {
                                TESTmethod_ADD(program.id);
                              }}
                            >
                              <AddCircle />
                            </ButtonSaveAndClose>
                          </Grid>
                          <Grid item xs={12} sm={4}></Grid>
                        </Grid>
                      );
                    })}
                  </>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Paper>
    </div>
  );
}
export default React.memo(LoginAssignProgramsList);
